import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import React, {Fragment} from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

/**
 * Lists the arbor registration classes that have a lesson on the given date and session.
 *
 * Stays disabled, and doesn't fetch, until the date and session filters are both set (enabled).
 *
 * The options carry the arbor lesson_wonde_id so the attendance writeback doesn't have to look it up again.
 */
const DropdownArborGroupList = ({control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id, onChange, session, date, enabled}) =>
{
    const buildUrl = () =>
    {
        if (enabled !== true || school_id === undefined || school_id === null)
        {
            //A null url tells useListboxFetch not to fetch until the other filters are in place
            return null;
        }

        const params = new URLSearchParams();

        if (session !== undefined && session !== null)
        {
            params.append('session', session);
        }

        if (date !== undefined && date !== null)
        {
            params.append('date', date);
        }

        const query = params.toString();

        return '/school/' + school_id + '/arbor/lessons' + (query === '' ? '' : '?' + query);
    }

    const fields = {
        url: buildUrl(),
        keyFieldName: 'class_id',
        labelFieldName: 'group_name',
        additionalFields: ['group_id', 'lesson_wonde_id', 'class_wonde_id', 'lesson_start', 'member_count', 'year_name'],
    };

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly || enabled !== true} /> }
        </Fragment>
    )

}

export default DropdownArborGroupList;
